import { render, staticRenderFns } from "./CreateSppd.vue?vue&type=template&id=14f06c4e&"
import script from "./CreateSppd.vue?vue&type=script&lang=js&"
export * from "./CreateSppd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports